module.exports = __webpack_public_path__ + "static/media/picture.c4113375.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture.jpeg
// module id = 73
// module chunks = 0